<template>
  <div class="slider-box">
    <el-slider v-bind="$attrs" :format-tooltip="formatTooltip" v-model="dataValue" @change="onValueChange"></el-slider>
    <span>{{ dataValue }}%</span>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: [Number, String],
    default: ''
  }
})
// eslint-disable-next-line
const emits = defineEmits(['input'])

const dataValue = ref(props.value)
const onValueChange = () => {
  emits('input', dataValue.value)
}

const formatTooltip = (value) => {
  return `${value}%`
}
</script>

<style scoped lang="scss">
.slider-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  ::v-deep .el-slider {
    flex: 1;
    .el-slider__button-wrapper {
      z-index: 10;
    }
  }
  > span {
    min-width: 40px;
    text-align: right;
  }
}
</style>
